export const ADDITIONAL_APPROVERS_DESCRIPTION = "Add more approvers to expedite your Purchaser's in-store experience if you're unavailable. Purchase approval requests will be sent via text to all listed approvers individually.";
